import React from 'react';
import { Link } from 'react-router-dom';
//  import {logo1} from  "../../../logo/logo1.jpg"
 
const Navbar = () => {
    return (
            <nav class="navbar navbar-expand-lg navbar-light  ">
  <a class="navbar-brand" href="#">
      <img src="Logo.png" alt="not loading" className="img-fluid rounded-circle" style={{width:'90px'}}/>
  </a>
  <button class="navbar-toggler bg-light text-danger font-weight-bold" type="button" data-toggle="collapse" data-target="#navbarNav"  >
    <span class="navbar-toggler-icon text-light"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav ml-auto mx-3">
      <li class="nav-item  active font-weight-bold  mx-3">
        <a class="nav-link text-white" href="#headerContainer">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item  active font-weight-bold  mx-3">
       <Link to="/Onudaan"><a class="nav-link text-white" href="#">Donations<span class="sr-only">(current)</span></a>
       </Link></li>
      <li class="nav-item active font-weight-bold mx-3">
        <a class="nav-link text-white" href="#AboutUs">About Us <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active font-weight-bold mx-3">
        <a class="nav-link text-white" href="#OurTeam">Our Team <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active font-weight-bold mx-3">
        <a class="nav-link text-white" href="#ContactUs">Contact Us <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active  ml-3">
      <Link to="/Afterlogin">
        <button className="btn btn-dark">
            Login
        </button> 
         </Link>
      </li>
    </ul>
  </div>
</nav>
    );
};

export default Navbar;